<template>
  <div class="page page-cover">
    <div class="cover-content">
      <div class="cover-top">
        <div class="cover-top-logo" v-if="hasLogo">
          <img :src="this.dealer.logo" />
        </div>
        <div class="cover-top-info" v-if="hasRep">
          <div class="rep-name">
            {{ projectRep.name }}
          </div>
          <div class="rep-email">
            {{ projectRep.email }}
          </div>
          <div class="rep-phone">
            {{ projectRep.phone }}
          </div>
        </div>
      </div>
      <div class="cover">
        <div
          class="cover-heroes"
          v-if="coverProducts.length"
          :class="coverHeroesClass"
        >
          <Product
            v-for="(product, index) in coverProducts"
            :key="index + '-ch-' + (product && product.style_id)"
            :originalProduct="product"
            :designName="coverProductsDesigns[index]"
            :hideInfo="true"
            :readOnly="true"
            :withImage="true"
          />
        </div>
        <div class="cover-backgrounds">
          <component
            v-for="(_bk, i) in ['', '', '']"
            :key="i + '-bk'"
            :is="getCoverBackgroundComponent(i)"
            :fill="getCoverBackgroundColor(i)"
            class="cover-background-item"
          />
        </div>
      </div>
      <div class="cover-footer">
        <div class="cover-title-container">
          <div class="cover-title slate-bold">
            {{ title }}
          </div>
        </div>
        <div class="divider"></div>
        <div class="cover-footer-branding">
          <Branding
            v-for="(brand, index) in branding"
            :key="index + '-branding-cover'"
            :brand="brand"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import Branding from "@/components/Projects/Playbooks/Cover/Branding.vue";
import Product from "@/components/Projects/Product/Product.vue";
import BasketballCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/BasketballCover_c1.vue";
import BasketballCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/BasketballCover_c2.vue";
import BasketballCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/BasketballCover_c3.vue";
import SportsCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/SportsCover_c1.vue";
import SportsCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/SportsCover_c2.vue";
import SportsCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/SportsCover_c3.vue";
import CategoryCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/CategoryCover_c1.vue";
import CategoryCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/CategoryCover_c2.vue";
import CategoryCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/CategoryCover_c3.vue";
import BaseballCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/BaseballCover_c1.vue";
import BaseballCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/BaseballCover_c2.vue";
import BaseballCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/BaseballCover_c3.vue";
import FastpitchCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/FastpitchCover_c1.vue";
import FastpitchCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/FastpitchCover_c2.vue";
import FastpitchCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/FastpitchCover_c3.vue";
import FootballCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/FootballCover_c1.vue";
import FootballCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/FootballCover_c2.vue";
import FootballCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/FootballCover_c3.vue";
import LacrosseCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/LacrosseCover_c1.vue";
import LacrosseCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/LacrosseCover_c2.vue";
import LacrosseCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/LacrosseCover_c3.vue";
import SoccerCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/SoccerCover_c1.vue";
import SoccerCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/SoccerCover_c2.vue";
import SoccerCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/SoccerCover_c3.vue";
import TrackCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/TrackCover_c1.vue";
import TrackCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/TrackCover_c2.vue";
import TrackCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/TrackCover_c3.vue";
import VolleyballCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/VolleyballCover_c1.vue";
import VolleyballCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/VolleyballCover_c2.vue";
import VolleyballCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/VolleyballCover_c3.vue";
import WrestlingCover_c1 from "@/components/Projects/Playbooks/Cover/Backgrounds/WrestlingCover_c1.vue";
import WrestlingCover_c2 from "@/components/Projects/Playbooks/Cover/Backgrounds/WrestlingCover_c2.vue";
import WrestlingCover_c3 from "@/components/Projects/Playbooks/Cover/Backgrounds/WrestlingCover_c3.vue";

export default {
  name: "Cover",

  components: {
    Branding,
    Product,
    BasketballCover_c1,
    BasketballCover_c2,
    BasketballCover_c3,
    SportsCover_c1,
    SportsCover_c2,
    SportsCover_c3,
    CategoryCover_c1,
    CategoryCover_c2,
    CategoryCover_c3,
    BaseballCover_c1,
    BaseballCover_c2,
    BaseballCover_c3,
    FastpitchCover_c1,
    FastpitchCover_c2,
    FastpitchCover_c3,
    FootballCover_c1,
    FootballCover_c2,
    FootballCover_c3,
    LacrosseCover_c1,
    LacrosseCover_c2,
    LacrosseCover_c3,
    SoccerCover_c1,
    SoccerCover_c2,
    SoccerCover_c3,
    TrackCover_c1,
    TrackCover_c2,
    TrackCover_c3,
    VolleyballCover_c1,
    VolleyballCover_c2,
    VolleyballCover_c3,
    WrestlingCover_c1,
    WrestlingCover_c2,
    WrestlingCover_c3,
  },

  props: {
    page: {
      type: Object,
    },
  },

  computed: {
    ...mapState("catalog", ["projectCatalogs", "projectProducts"]),
    ...mapState(["dealer"]),
    ...mapState("playbook", ["catalogs", "title"]),

    ...mapGetters("playbook", [
      "color1",
      "color2",
      "color3",
      "branding",
      "isSchool",
      "isTeam",
      "playbookPages",
      "playbookProducts",
    ]),
    ...mapGetters("project", ["projectRep"]),
    ...mapGetters("threekit", ["getProductByStyleName"]),

    coverHeroesClass() {
      return {
        unique: this.coverProducts?.length === 1,
        double: this.coverProducts?.length === 2,
        triple: this.coverProducts?.length === 3,
      };
    },

    coverProducts() {
      const selectedSports = this.projectCatalogs.filter((catalog) => {
        //Search if the project has pages with the catalog
        return this.playbookPages.some(
          (page) =>
            page.catalog &&
            page.catalog.toLowerCase() === catalog.name?.toLowerCase()
        );
      });

      const products = selectedSports.map((projectCatalog) => {
        return this.playbookProducts?.find(
          (pr) =>
            pr.catalogName?.toLowerCase() ===
            projectCatalog?.name?.toLowerCase()
        );
      });

      return products?.length > 3 ? products.slice(0, 3) : products;
    },

    coverProductsDesigns() {
      return this.coverProducts?.map((pr) => {
        const prData = this.getProductByStyleName(pr?.styleId);

        return prData && Object.keys(prData?.designs)?.[0];
      });
    },

    hasLogo() {
      return !!this.dealer?.logo;
    },

    hasRep() {
      return !!this.projectRep;
    },

    sportNames() {
      return this.catalogs
        ?.map((sport) => {
          return sport.name;
        })
        .slice(0, 5); //max 5 sport-heroes in the cover
    },
  },

  methods: {
    getCoverBackground(i) {
      return require(`@/assets/cover-backgrounds/basketball_c${i + 1}`);
    },

    getCoverBackgroundComponent(i) {
      let sportCover = "";

      if (!this.isSchool && !this.isTeam) {
        sportCover = "CategoryCover";
      } else if (this.projectCatalogs.length === 1) {
        //Track exception
        if (this.projectCatalogs?.[0]?.name === "Track & Cross Country") {
          sportCover = `TrackCover`;
          return `${sportCover}_c${i + 1}`;
        }

        const coverSportsAllowed = [
          "baseball",
          "basketball",
          "fastpitch",
          "football",
          "lacrosse",
          "soccer",
          "track",
          "volleyball",
          "wrestling",
        ];

        if (
          coverSportsAllowed.includes(
            this.projectCatalogs?.[0]?.name?.toLowerCase()
          )
        ) {
          sportCover = `${this.projectCatalogs?.[0]?.name}Cover`;
        } else {
          sportCover = "SportsCover";
        }
      } else {
        sportCover = "SportsCover";
      }

      return `${sportCover}_c${i + 1}`;
    },
    getCoverBackgroundColor(i) {
      return this[`color${i + 1}`]?.hex;
    },

    getDesignName(pr) {
      return this.getProductByStyleName(pr?.styleId)?.designs?.[0];
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .project-page {
    /* general for fsg and ua */
    .page-cover {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0;

      .cover-content {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        z-index: 1;
        height: 100%;

        .cover-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 15%;
          padding: 1em 1em 1em;
          padding-bottom: 2em;

          .cover-top-logo {
            max-height: 5em;
            max-width: 50%;
            img {
              max-width: 100%;
              max-height: 5em;
            }
          }

          .cover-top-info {
            display: flex;
            flex-direction: column;
            font-size: 1.2em;

            .rep-name {
              font-weight: bold;
            }
          }
        }
        .cover {
          height: 60%;
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;

          overflow: hidden;
          position: relative;
          .cover-heroes {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            z-index: 1;
            .product {
              position: absolute;
              background: transparent;
            }

            &.unique {
              .product {
                position: relative;
                margin: auto;
              }
            }
            &.double {
              .product {
                width: 50%;
              }
              .product:nth-child(1) {
                bottom: 0;
                left: 0%;
                max-height: 95%;
                z-index: 2;
              }
              .product:nth-child(2) {
                top: 0;
                max-height: 75%;
                right: 0%;
              }
            }
            &.triple {
              .product:nth-child(1) {
                bottom: -2%;
                left: 15%;
                width: 70%;
                max-height: 90%;
                z-index: 2;
              }
              .product:nth-child(2) {
                top: 0;
                left: -5%;
                width: 50%;
              }
              .product:nth-child(3) {
                top: 0;
                right: -5%;
                width: 50%;
              }

              .product:nth-child(2),
              .product:nth-child(3) {
                max-height: 55%;
                z-index: 1;
              }
            }
          }

          .cover-backgrounds {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 0;
            .cover-background-item {
              width: 100%;
              height: 100%;
              position: absolute;
            }
          }
        }

        .cover-footer {
          width: 100%;
          height: 20%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          background-color: $white;
          z-index: 5;

          .cover-title-container {
            display: flex;
            flex-direction: column;
            align-items: center;

            .cover-title {
              font-size: 2.5em;
              text-transform: capitalize;
              text-align: center;
            }
          }

          .divider {
            height: 1px;
            width: 70%;
            background-color: $grey-light;
          }

          .cover-footer-branding {
            max-width: 70%;
            display: flex;
            justify-content: center;
            height: 4.5em;
            padding: 0.5em 1em;

            ::v-deep .cover-branding {
              margin: 0 0.75rem;
            }
          }
        }
      }
      .cover-decorations {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 95%;
        display: flex;
      }
    }

    /* fsg */
    &.template-fsg {
      .page-cover {
        overflow: hidden;
        .cover-decorations {
          justify-content: center;
          z-index: 2;
          transform: rotate(83deg);
          height: 95%;
          .cover-decoration-color-a {
            width: 5%;
            // margin: 0 3%;
          }
          .cover-decoration-color-b {
            width: 5%;
          }
          .cover-decoration-color-c {
            width: 3%;
            // margin: 0 3%;
          }
        }
      }
    }

    /* ua */
    &.template-ua {
      .page-cover {
        .cover-decorations {
          justify-content: center;
          z-index: 0;
          .cover-decoration-color-a {
            width: 2.5%;
          }
          .cover-decoration-color-b {
            width: 50%;
          }
          .cover-decoration-color-c {
            width: 2.5%;
          }
        }
      }
    }
  }
}
</style>
